<template>
  <div class="text-center d-flex justify-content-center ta-verify-condition-report-request">
    <div v-if="loading">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="info"
        class="ta-verify-condition-report-request-loading-spinner"
      />
      <h4
        class="ta-verify-condition-report-request-loading-text"
      >
        {{ $t('Verifying Condition Report Request') }}...
      </h4>
    </div>
    <FormAlert
      :success-message="successMessage"
      :error-message="errorMessage"
      v-else
    />
  </div>
</template>

<script>
import FormAlert from "@/components/core/FormAlert";
import axiosClient from "@/services/axios";

export default {
  name: "VerifyConditionReportRequest",
  components: {FormAlert},
  data() {
    return {
      loading: true,
      successMessage: '',
      errorMessage: ''
    }
  },
  methods: {
    async verifyConditionReportRequest(token) {
      return new Promise((resolve, reject) => {
        axiosClient.post(
          'website/condition-report-requests/verification/',
          {'token': token}
        ).then((response) => {
          resolve(response.data.message);
        }).catch((err) => {
          reject(err.response.data['Error']);
        })
      });
    },
  },
  beforeMount() {
    const token = this.$route.params.token
    this.verifyConditionReportRequest(token)
      .then((msg) => {
        this.loading = false;
        this.successMessage = msg;
      })
      .catch((msg) => {
        this.loading = false;
        this.errorMessage = msg;
      });
  }
}
</script>
